import { Injectable } from '@angular/core';

// SERVICES
import { Observable } from 'rxjs';

import { EnvironmentUtilService } from '../../util';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class HubSpotApiService {
  environment = this.environmentUtilService.getEnvironment();

  constructor(
    private apiService :ApiService,
    private environmentUtilService :EnvironmentUtilService,
  ) {}

  getAuthorizationUrl(appIntegrationAccountId :number) :Observable<any> {
    return this.apiService.get(
      `${this.environment.urlV2}/hubspot/authorize/${appIntegrationAccountId}`,
    );
  }

  syncData(appIntegrationAccountId :number, syncSettings :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/hubspot/sync/${appIntegrationAccountId}`,
      body: syncSettings,
    });
  }

  testCredentials(credentials :any) :Observable<any> {
    return this.apiService.post({
      path: `${this.environment.urlV2}/hubspot/test-credentials`,
      body: credentials,
    });
  }
} 